import * as React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import { makeStyles } from "@mui/styles";
import { Typography } from "../Typography";

const useStyles = makeStyles((theme) => ({
  contents: {
    // padding: "0px 0px",
  },
  dot1: {
    marginBottom: 0,
    display: "flex",
  },
  verticalLine: {
    position: "relative",
    top: "12px",
    color: "#EB4FE5",
  },
  connector: {
    backgroundColor: "#EB4FE5",
  },
  tdate: {
    padding: "0px 23px",
  },
}));

export default function MobileTimeline() {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Timeline position="alternate">
        <TimelineItem sx={{ minHeight: "50px" }}>
          <TimelineOppositeContent>
            <Typography variant="SubTitle2">21년 11월</Typography>
          </TimelineOppositeContent>
          <TimelineSeparator
            classes={{
              root: classes.verticalLine,
            }}
          >
            <TimelineDot
              color="primary"
              sx={{
                marginTop: "1px",
                marginBottom: 0,
                borderWidth: "0.1px",
              }}
            />
            <TimelineConnector
              sx={{
                backgroundColor: "#eb4fe5",
              }}
            />
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="SubTitle2">
              ㈜휴먼브릿지 홈페이지 OPEN
            </Typography>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem sx={{ minHeight: "50px" }}>
          <TimelineOppositeContent>
            <Typography variant="SubTitle2">
              SimBridge 교수자 모드 OPEN
            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator
            classes={{
              root: classes.verticalLine,
            }}
          >
            <TimelineDot
              color="primary"
              sx={{ marginTop: 0, marginBottom: 0, borderWidth: "0.1px" }}
            />
            <TimelineConnector
              sx={{
                backgroundColor: "#eb4fe5",
              }}
            />
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="SubTitle2">21년 09월</Typography>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem sx={{ minHeight: "50px" }}>
          <TimelineOppositeContent>
            <Typography variant="SubTitle2">21년 08월</Typography>
          </TimelineOppositeContent>
          <TimelineSeparator
            classes={{
              root: classes.verticalLine,
            }}
          >
            <TimelineDot
              color="primary"
              sx={{ marginTop: 0, marginBottom: 0, borderWidth: "0.1px" }}
            />
            <TimelineConnector
              sx={{
                backgroundColor: "#eb4fe5",
              }}
            />
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="SubTitle2">
              SimBridge 간호관리 시뮬레이션 5 모듈 OPEN
            </Typography>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem sx={{ minHeight: "50px" }}>
          <TimelineOppositeContent>
            <Typography variant="SubTitle2">
              한국간호행정학회 춘계학술대회 우수포스터상 수상 “ 사례기반 VR
              간호관리실습 프로그램 개발 및 평가＂
            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator
            classes={{
              root: classes.verticalLine,
            }}
          >
            <TimelineDot
              color="primary"
              sx={{ marginTop: 0, marginBottom: 0, borderWidth: "0.1px" }}
            />
            <TimelineConnector
              sx={{
                backgroundColor: "#eb4fe5",
              }}
            />
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="SubTitle2">21년 06월</Typography>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem sx={{ minHeight: "50px" }}>
          <TimelineOppositeContent>
            <Typography variant="SubTitle2">21년 06월</Typography>
          </TimelineOppositeContent>
          <TimelineSeparator
            classes={{
              root: classes.verticalLine,
            }}
          >
            <TimelineDot
              color="primary"
              sx={{ marginTop: 0, marginBottom: 0, borderWidth: "0.1px" }}
            />
            <TimelineConnector
              sx={{
                backgroundColor: "#eb4fe5",
              }}
            />
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="SubTitle2">
              한국보건산업진흥원 고령친화 해외진출 전문인력양성사업 선정
            </Typography>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem sx={{ minHeight: "50px" }}>
          <TimelineOppositeContent>
            <Typography variant="SubTitle2">
              SimBridge 정신간호 시뮬레이션 5 모듈 OPEN
            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator
            classes={{
              root: classes.verticalLine,
            }}
          >
            <TimelineDot
              color="primary"
              sx={{ marginTop: 0, marginBottom: 0, borderWidth: "0.1px" }}
            />
            <TimelineConnector
              sx={{
                backgroundColor: "#eb4fe5",
              }}
            />
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="SubTitle2">21년 03월</Typography>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem sx={{ minHeight: "50px" }}>
          <TimelineOppositeContent>
            <Typography variant="SubTitle2">21년 01월</Typography>
          </TimelineOppositeContent>
          <TimelineSeparator
            classes={{
              root: classes.verticalLine,
            }}
          >
            <TimelineDot
              color="primary"
              sx={{ marginTop: 0, marginBottom: 0, borderWidth: "0.1px" }}
            />
            <TimelineConnector
              sx={{
                backgroundColor: "#eb4fe5",
              }}
            />
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="SubTitle2">
              가상 온라인 실습 플랫폼 OPEN
            </Typography>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem sx={{ minHeight: "50px" }}>
          <TimelineOppositeContent>
            <Typography variant="SubTitle2">
              SimBridge Prototype Market Test
            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator
            classes={{
              root: classes.verticalLine,
            }}
          >
            <TimelineDot
              color="primary"
              sx={{ marginTop: 0, marginBottom: 0, borderWidth: "0.1px" }}
            />
            <TimelineConnector
              sx={{
                backgroundColor: "#eb4fe5",
              }}
            />
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="SubTitle2">21년 01월</Typography>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem sx={{ minHeight: "50px" }}>
          <TimelineOppositeContent>
            <Typography variant="SubTitle2">21년 01월</Typography>
          </TimelineOppositeContent>
          <TimelineSeparator
            classes={{
              root: classes.verticalLine,
            }}
          >
            <TimelineDot
              color="primary"
              sx={{ marginTop: 0, marginBottom: 0, borderWidth: "0.1px" }}
            />
            <TimelineConnector
              sx={{
                backgroundColor: "#eb4fe5",
              }}
            />
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="SubTitle2">
              (사)KVN한국방문간호사회 MOU 체결
            </Typography>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem sx={{ minHeight: "50px" }}>
          <TimelineOppositeContent>
            <Typography variant="SubTitle2">
              특허 출원(10-2020-0187761) 비대면 간호교육서비스 제공시스템
            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator
            classes={{
              root: classes.verticalLine,
            }}
          >
            <TimelineDot
              color="primary"
              sx={{ marginTop: 0, marginBottom: 0, borderWidth: "0.1px" }}
            />
            <TimelineConnector
              sx={{
                backgroundColor: "#eb4fe5",
              }}
            />
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="SubTitle2">20년 12월</Typography>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem sx={{ minHeight: "50px" }}>
          <TimelineOppositeContent>
            <Typography variant="SubTitle2">20년 09월</Typography>
          </TimelineOppositeContent>
          <TimelineSeparator
            classes={{
              root: classes.verticalLine,
            }}
          >
            <TimelineDot
              color="primary"
              sx={{ marginTop: 0, marginBottom: 0, borderWidth: "0.1px" }}
            />
            <TimelineConnector
              sx={{
                backgroundColor: "#eb4fe5",
              }}
            />
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="SubTitle2">(주)휴먼브릿지 설립</Typography>
          </TimelineContent>
        </TimelineItem>
        <TimelineItem sx={{ minHeight: "50px" }}>
          <TimelineOppositeContent>
            <Typography variant="SubTitle2">
              한국보건산업진흥원 예비창업패키지 사업 선정
            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator
            classes={{
              root: classes.verticalLine,
            }}
          >
            <TimelineDot
              color="primary"
              sx={{ marginTop: 0, marginBottom: 0, borderWidth: "0.1px" }}
            />
            {/* <TimelineConnector /> */}
          </TimelineSeparator>
          <TimelineContent>
            <Typography variant="SubTitle2">20년 06월</Typography>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </React.Fragment>
  );
}
